import each from 'lodash/each'

import 'leaflet'
import 'leaflet.markercluster'
import 'leaflet-providers'
import { SearchControl, GeoSearchControl, OpenStreetMapProvider, GoogleProvider } from 'leaflet-geosearch'
// import 'https://tiles.locationiq.com/v3/libs/leaflet-geocoder/1.9.6/leaflet-geocoder-locationiq.min.js'
// import 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.3/leaflet.js'
// import 'https://tiles.locationiq.com/v3/js/liq-styles-ctrl-leaflet.js?v=0.1.8'
// import 'https://cdnjs.cloudflare.com/ajax/libs/leaflet-plugins/3.0.2/control/Permalink.js'

import gsap from 'gsap'

import { world } from '../utils/geolocation'
import { app } from '../utils/store'
import { getData, setParameters } from '../utils/json'

export default class Maps {
    constructor({
        element,
        zoom = {},
        infowindow = null,
        coordinates = {},
        query = null,
        controls = false,
        ui = false,
        wheel = false,
        fullscreen = false,
        streetView = false,
        mapTypeControl = false,
        draggable = false,
        api = {
            namespace: null,
            endpoint: null,
            arguments: null
        },
        stores = null,
        filter = null
    }, search = null) {
        if (element) {
            this.element = element

            this.map = {
                zoom: zoom,
                coordinates: coordinates,
                controls: controls,
                ui: ui,
                wheel: wheel,
                fullscreen: fullscreen,
                streetView: streetView,
                mapTypeControl: mapTypeControl,
                draggable: draggable,
                stores: stores,
            }

            this.stores = document.querySelector('.stores-list')
        } else {
            this.map = null
        }

        this.geolocate = document.getElementById('geolocate-toggler')
        this.form = {
            element: document.getElementById('map-search'),
            input: document.getElementById('store-search'),
            submit: document.getElementById('store-submit')
        }

        this.searchDebounceTimer = null;
    }

    async create({ search = null, markers = null, markersList = null }, query = false) {
        if (this.element) {
            this.createView(query)
            if (markers) { this.createMarkers() }
        }

        if (search) {
            this.createSearch(search, {
                // available: this.places,
                autocomplete: true,
                geolocate: search.geolocate ? search.geolocate : null,
                map: this.map
            })
        }
    }

    createView = (query) => {
        this.view = L.map('map', {
            center: [this.map.coordinates.lat, this.map.coordinates.lng],
            zoom: this.map.zoom.value,
            zoomControl: this.map.zoom.controls.enable,
            boxZoom: false,
            doubleClickZoom: false,
            scrollWheelZoom: this.map.wheel,
            dragging: this.map.draggable,
        })
        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png', {
            // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            // subdomains: 'abcd',
            // maxZoom: 20
        }).addTo(this.view)

        if(query){
            L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_only_labels/{z}/{x}/{y}{r}.png', {
                // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
                // subdomains: 'abcd',
                // maxZoom: 20
            }).addTo(this.view);
        }

        // L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.{ext}', {
        //     // minZoom: 0,
        //     // maxZoom: 20,
        //     // attribution: '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        //     ext: 'png'
        // }).addTo(this.view);

        // var key = 'pk.5db283d3f00addb24d2fb51f38ba390e';

        // L.control.geocoder(key, {
        //     // placeholder: 'Search nearby',
        //     url: "https://api.locationiq.com/v1",
        //     expanded: true,
        //     panToPoint: true,
        //     focus: true,
        //     position: "topright"
        // }).addTo(this.view);

        L.control.zoom().addTo(this.view)
    }

    createMarkers = (filter) => {
        if (this.clusters) { this.resetClusters() }

        this.locations = []

        each(this.map.stores, (entry) => {
            if (entry.dataset.location) {
                let location = JSON.parse(entry.dataset.location)

                if (location.lat && location.lng) {
                    if (filter) {
                        if (filter == location.filter) {
                            this.locations.push({
                                id: entry.dataset.id,
                                title: entry.dataset.title,
                                website: location.website,
                                city: location.mark.city,
                                address: location.mark.address,
                                lat: parseFloat(location.lat),
                                lng: parseFloat(location.lng),
                                spaces: location.spaces,
                                filter: location.filter
                            })
                        }
                    } else {
                        this.locations.push({
                            id: entry.dataset.id,
                            title: entry.dataset.title,
                            website: location.website,
                            city: location.mark.city,
                            address: location.mark.address,
                            lat: parseFloat(location.lat),
                            lng: parseFloat(location.lng),
                            spaces: location.spaces,
                            filter: location.filter
                        })
                    }
                }
            }
        })

        this.markers = this.locations.map((position, index) => {
            let popup =
                `<div class="infobox" data-mark="${position.id}">
                    <span class="city">${position.city}</span>
                    <span class="h5 name">${position.title}</span>
                    <p>${position.address}</p>
                    <a href="https://www.google.com/maps/dir/${position.lat},${position.lng}/" class="btn-default" target="_blank">Raggiungi lo store</a>
                </div>`

            if (position.website) {
                popup =
                    `<div class="infobox" data-mark="${position.id}">
                    <span class="city">${position.city}</span>
                    <span class="h5 name">${position.title}</span>
                    <p>${position.address}</p>
                    <a class="h5 website" href="${position.website}" target="_blank">${position.website}</a>
                    <a href="https://www.google.com/maps/dir/${position.lat},${position.lng}/" class="btn-default" target="_blank">Raggiungi lo store</a>
                </div>`
            }

            let icon = L.icon({
                iconUrl: position.spaces ? `${config.theme}/dist/img/vectors/icon-marker-1.svg` : `${config.theme}/dist/img/vectors/icon-marker-2.svg`,
                iconSize: [38, 44],
                iconAnchor: [12, 30],
                popupAnchor: [0, -25],
                className: `marker-${position.id}` + ` ` + (position.spaces ? `marker-spaces` : `marker-basics`)
            })

            let marker = L.marker(
                [position.lat, position.lng],
                { icon: icon, alt: position.spaces ? `marker-spaces` : `marker-basics` }
            )
            // .addTo(this.map)

            marker.id = position.id
            // marker._icon.classList.add(position.spaces ? `marker-basics` : `marker-spaces`)
            // marker._icon.classList.add(`marker-${marker.id}`)

            marker.on('click', (event) => {
                let tease = document.querySelector(`[data-id="${event.target.id}"]`)

                tease.classList.add('highlight')
                gsap.to(app.html, {
                    duration: .5,
                    scrollTo: tease.offsetTop - app.header.clientHeight,
                    ease: 'Power2.easeInOut',
                })
            })
            marker.on('mouseover', (event) => { document.querySelector(`[data-id="${event.target.id}"]`).classList.add('highlight') })
            marker.on('mouseout', (event) => { document.querySelector(`[data-id="${event.target.id}"]`).classList.remove('highlight') })

            marker.bindPopup(popup).openPopup()

            return marker
        })

        this.createClusters(filter)
    }

    resetClusters = () => {
        this.view.removeLayer(this.clusters)
    }

    createClusters = (filter) => {
        if (filter && filter == 'spaces') {
            this.clusters = L.markerClusterGroup({
                showCoverageOnHover: false,
                iconCreateFunction: (cluster) => {
                    return L.divIcon({
                        html: `<span class="counter">${cluster.getChildCount()}</span>
                        <svg fill="${design.color.accent}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                            <circle cx="120" cy="120" opacity="1" r="70" />
                            <circle cx="120" cy="120" opacity=".7" r="90" />
                            <circle cx="120" cy="120" opacity=".3" r="110" />
                        </svg>`
                    })
                }
            })
        } else {
            this.clusters = L.markerClusterGroup({
                showCoverageOnHover: false,
                iconCreateFunction: (cluster) => {
                    return L.divIcon({
                        html: `<span class="counter">${cluster.getChildCount()}</span>
                        <svg fill="${design.color.third}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                            <circle cx="120" cy="120" opacity="1" r="70" />
                            <circle cx="120" cy="120" opacity=".7" r="90" />
                            <circle cx="120" cy="120" opacity=".3" r="110" />
                        </svg>`
                    })
                }
            })
        }

        each(this.markers, (marker) => {
            this.clusters.addLayer(marker)
        })

        let filters = document.querySelectorAll('#results .filter-togglers button'),
            pins = document.querySelectorAll(`img.leaflet-marker-icon`),
            teases = document.querySelectorAll('.tease.available')

        this.clusters.on('clusterclick', () => {
            each(pins, (marker) => { marker.style.setProperty('display', 'block') })
            if (filters) {
                each(filters, (button) => {
                    each(teases, (tease) => { tease.style.setProperty('display', 'block') })
                    button.classList.remove('active')
                })
            }
        })

        this.view.addLayer(this.clusters)
    }

    createLocateUser = () => {
        this.geolocate.onclick = (event) => {
            event.preventDefault()
            event.stopPropagation()
            navigator.geolocation.getCurrentPosition(
                // On Success
                async (position) => {
                    let coordinates = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude)
                    }

                    try {
                        let data = await this.reverseGeocoding(position.coords)
                        if (data && this.form.input) {
                            // Verifica che ci sia una città nei risultati
                            const city = data.address.city || data.address.town || data.address.village
                            if (city) {
                                this.form.input.value = city
                                // Trigger della ricerca con i nuovi dati
                                this.createStores(event, true, true)
                            }
                        }
                    } catch (error) {
                        console.error('Errore nella geolocalizzazione:', error)
                    }
                },
                // On Error
                (error) => {
                    console.error(error)
                }
            )

            navigator.geolocation.watchPosition(
                // On Success
                (position) => { },
                // On Error
                (error) => { if (error.code == error.PERMISSION_DENIED) { app.html.setAttribute('geolocate', false) } }
            )
        }
    }

    createSearch = async (search, { available = null, autocomplete = false, geolocate = null }) => {
        this.search = search

        if (geolocate) {
            this.createLocateUser()
        }

        if (autocomplete) {
            // Creiamo un solo elemento autocomplete
            this.autocomplete = {
                element: document.createElement('ul'),
                options: [],
                isVisible: false,
                selectedIndex: -1
            }

            this.autocomplete.element.className = 'autocomplete hidden'
            this.form.element.append(this.autocomplete.element)

            // Sincronizzazione degli input e gestione dell'autocomplete
            const handleInput = (source) => {
                if (source.value.length > 2) {
                    this.createStores({ type: 'input', target: source }, false, false)
                } else {
                    this.clearAutocomplete()
                }
            }

            // Eventi per gli input
            this.form.input.addEventListener('input', (e) => handleInput(e.target))

            // Eventi per i submit
            const handleSubmit = (e) => {
                e.preventDefault()
                if (this.form.input.value.length > 2) {
                    this.createStores(e, true, false)
                }
            }

            this.form.submit.addEventListener('click', handleSubmit)

            // Gestione della navigazione con tastiera per l'input
            const handleKeydown = (event) => {
                switch (event.key) {
                    case 'ArrowDown':
                        event.preventDefault()
                        this.navigateAutocomplete(1)
                        break
                    case 'ArrowUp':
                        event.preventDefault()
                        this.navigateAutocomplete(-1)
                        break
                    case 'Enter':
                        event.preventDefault()
                        if (this.autocomplete.selectedIndex >= 0) {
                            this.selectAutocompleteOption(this.autocomplete.selectedIndex)
                        }
                        break
                    case 'Escape':
                        this.clearAutocomplete()
                        break
                }
            }

            this.form.input.addEventListener('keydown', handleKeydown)
        }
    }

    createStores = async (event, autoclick = false, geolocated = false) => {
        if (event.type == 'submit') { event.preventDefault() }

        // Clear previous timer
        if (this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }

        // Clear results before new search
        this.clearAutocomplete();

        // Debounce the search
        this.searchDebounceTimer = setTimeout(async () => {
            const results = await this.autoComplete(this.form.input.value)

            each(results, (entry, index) => {
                if (index < 10) {
                    let option = document.createElement('li')

                    option.setAttribute('data-coordinates', `${entry.lat},${entry.lon}`)
                    option.setAttribute('data-bound', entry.boundingbox[0])
                    option.setAttribute('data-index', index)
                    option.innerText = entry.display_name

                    option.onclick = (event) => {
                        this.search.clicked = true

                        if (this.stores) {
                            this.stores.innerHTML = ''
                            for (var index = this.markers.length, boundingbox = this.view.getBounds(); index--;) {
                                if (boundingbox.contains(this.markers[index].getLatLng())) {
                                    let n = document.createElement('div')
                                    n.classList.add('store-item')
                                    n.innerHTML = this.markers[index]._popup._content
                                    this.stores.append(n)
                                }
                            }
                        }

                        // Aggiorniamo solo l'input principale
                        this.form.input.value = entry.display_name

                        this.form.input.setAttribute('data-map', JSON.stringify({
                            query: entry.display_name,
                            lat: entry.lat,
                            lon: entry.lon
                        }))

                        this.hideAutocomplete()
                        this.element.parentNode.classList.add('value--filled')

                        setTimeout(() => {
                            this.search.clicked = false
                        }, 1000)
                    }

                    this.autocomplete.options.push({
                        label: entry.display_name,
                        item: option,
                        object: entry
                    })
                    this.autocomplete.element.append(option)
                }
            })

            if (this.autocomplete.options.length > 0) {
                this.showAutocomplete()
            }

            // Auto-click the first
            if (autoclick && this.autocomplete.options.length > 0) {
                this.autocomplete.element.firstElementChild.click()

                let data = getData(this.search.input)
                if (data) {
                    setParameters(new URL(window.location.href), data)
                    location.reload()
                }
            }
        }, 300);  // Aspetta 300ms prima di eseguire la ricerca
    }

    reverseGeocoding = async (position) => {
        let request = await fetch(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${position.latitude}&lon=${position.longitude}`)

        if (request.status === 200) {
            let response = await request.json()
            return response
        }
    }


    autoComplete = async (query) => {
        const italyBoundingBox = "6.7499552751,36.619987291,18.4802470232,47.1153931748";

        let request = await fetch(`https://api.locationiq.com/v1/autocomplete?` +
            `key=pk.eca9f287c6d6d25cd7fc3ed24bb19ca6` +
            `&q=${query}` +
            `&limit=5` +
            `&viewbox=${italyBoundingBox}` +
            `&prioritySort=1` +
            `&importanceSort=0` +
            `&tag=place:city,place:town,place:village` +
            `&dedupe=1`, {
            "async": true,
            "crossDomain": true,
            "method": "GET",
        })

        if (request.status === 200) {
            let response = await request.json()
            return response
        }
    }

    clearAutocomplete() {
        this.autocomplete.options = []
        this.autocomplete.element.innerHTML = ''
        this.autocomplete.selectedIndex = -1
        this.hideAutocomplete()
    }

    hideAutocomplete() {
        this.autocomplete.element.classList.add('hidden')
        this.autocomplete.isVisible = false
    }

    showAutocomplete() {
        this.autocomplete.element.classList.remove('hidden')
        this.autocomplete.isVisible = true
    }

    navigateAutocomplete(direction) {
        if (!this.autocomplete.isVisible || this.autocomplete.options.length === 0) return

        this.autocomplete.selectedIndex = Math.max(
            -1,
            Math.min(
                this.autocomplete.options.length - 1,
                this.autocomplete.selectedIndex + direction
            )
        )

        const options = this.autocomplete.element.querySelectorAll('li')
        options.forEach((option, index) => {
            option.classList.toggle('selected', index === this.autocomplete.selectedIndex)
        })
    }

    selectAutocompleteOption(index) {
        if (index >= 0 && index < this.autocomplete.options.length) {
            const option = this.autocomplete.element.children[index]
            if (option) {
                option.click()
            }
        }
    }
}
